<template>
	<div class="page">
		<div class="nucleustit">
			<div class="tit">核心数据</div>
			<div>
				<el-select :disabled="!$buttonAuthority('shuju-mendianshuju-shop')" style="width: 150px;" v-model="params.shopId"
					placeholder="请选择" size='mini' @change="changeShop">
					<el-option v-for="item in shopList" :key='item.shop_id' :label="item.shop_name"
						:value="item.shop_id">
					</el-option>
				</el-select>
				<el-date-picker style="width: 130px;margin-left: 10px;" size="mini" v-model="currDate" type="date"
					value-format="timestamp" :picker-options="{disabledDate(date) {return date.getTime() > Date.now()}}"
					placeholder="选择日期" @change="changePicker" :clearable="false">
				</el-date-picker>
				<el-select size="mini" v-model="params.dateType" placeholder="请选择"
					style="width: 100px;margin-left: 10px;" @change="changeDateType">
					<el-option label="查看当日" value="date"></el-option>
					<el-option label="查看当周" value="week"></el-option>
					<el-option label="查看当月" value="month"></el-option>
					<el-option label="查看当年" value="year"></el-option>
				</el-select>
			</div>
		</div>
		<div class="nucleus">
			<div class="nucleuscon">
				<div class="nucleusitem">
					<div class="content">
						<div class="currentit"> {{getText().current}}流水</div>
						<div class="data">
							<span v-if="!state1||!state2">0</span>
							<animate-number v-else from="0" :to="runningAmount.current"
								:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
							<el-tooltip effect="dark" placement="top-start">
								<div slot="content" style="line-height: 20px;">
									<div>订单金额：{{shopDetail.current&&shopDetail.current.runningAmount_OrderAmount}}</div>
									<div>退单金额：{{shopDetail.current&&shopDetail.current.runningAmount_ReturnAmount}}
									</div>
									<div>换货金额：{{shopDetail.current&&shopDetail.current.runningAmount_ReplaceAmount}}
									</div>
									<div>充值金额：{{shopDetail.current&&shopDetail.current.runningAmount_RechargeAmount}}
									</div>
									<div style="line-height: 6px;">----------------------------</div>
									<div>现金：{{shopDetail.current&&shopDetail.current.runningAmount_PayWay_Cash}}</div>
								</div>
								<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:10px;" />
							</el-tooltip>
						</div>
						<div v-if="runningAmount.old===0" class="compare" style="padding-top: 5px;">{{getText().old}}为 0
						</div>
						<div v-else class="compare">
							比
							<el-tooltip effect="dark" :content="runningAmount.old+''" placement="left">
								<span>{{getText().old}}</span>
							</el-tooltip>
							{{runningAmount.rate}}%
							<img v-if="runningAmount.rate>=0" src="../../assets/img/lvzhang.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
							<img v-if="runningAmount.rate<0" src="../../assets/img/hongdie.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
						</div>
					</div>
				</div>
				<div class="nucleusitem">
					<div class="content">
						<div class="currentit"> {{getText().current}}充值金额</div>
						<div class="data">
							<span v-if="!state1||!state2">0</span>
							<animate-number v-else from="0" :to="rechargeAmount.current"
								:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
							<el-tooltip effect="dark" placement="top-start">
								<div slot="content" style="line-height: 20px;">
									<div>充值金额：{{shopDetail.current&&shopDetail.current.rechargeAmount_RechargeAmount}}
									</div>
									<div>退款金额：{{shopDetail.current&&shopDetail.current.rechargeAmount_RetrunAmount}}
									</div>
								</div>
								<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:10px;" />
							</el-tooltip>
						</div>
						<div v-if="rechargeAmount.old===0" class="compare" style="padding-top: 5px;">{{getText().old}}为
							0</div>
						<div v-else class="compare">
							比
							<el-tooltip effect="dark" :content="rechargeAmount.old+''" placement="left">
								<span>{{getText().old}}</span>
							</el-tooltip>
							{{rechargeAmount.rate}}%
							<img v-if="rechargeAmount.rate>=0" src="../../assets/img/lvzhang.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
							<img v-if="rechargeAmount.rate<0" src="../../assets/img/hongdie.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
						</div>
					</div>
				</div>
				<div class="nucleusitem">
					<div class="content">
						<div class="currentit"> {{getText().current}}客单价 </div>
						<div class="data">
							<span v-if="!state1||!state2">0</span>
							<animate-number v-else from="0" :to="singleCustomerAmount.current"
								:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
						</div>
						<div v-if="singleCustomerAmount.old===0" class="compare" style="padding-top: 5px;">
							{{getText().old}}为 0
						</div>
						<div v-else class="compare">
							比
							<el-tooltip effect="dark" :content="singleCustomerAmount.old+''" placement="left">
								<span>{{getText().old}}</span>
							</el-tooltip>
							{{singleCustomerAmount.rate}}%
							<img v-if="singleCustomerAmount.rate>=0" src="../../assets/img/lvzhang.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
							<img v-if="singleCustomerAmount.rate<0" src="../../assets/img/hongdie.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
						</div>
					</div>
				</div>
				<div class="nucleusitem">
					<div class="content">
						<div class="currentit"> {{getText().current}}自用商品 </div>
						<div class="data">
							<span v-if="!state1||!state2">0</span>
							<animate-number v-else from="0" :to="shopUseAmount.current"
								:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
						</div>
						<div v-if="shopUseAmount.old===0" class="compare" style="padding-top: 5px;">{{getText().old}}为 0
						</div>
						<div v-else class="compare">
							比
							<el-tooltip effect="dark" :content="shopUseAmount.old+''" placement="left">
								<span>{{getText().old}}</span>
							</el-tooltip>
							{{shopUseAmount.rate}}%
							<img v-if="shopUseAmount.rate>=0" src="../../assets/img/lvzhang.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
							<img v-if="shopUseAmount.rate<0" src="../../assets/img/hongdie.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
						</div>
					</div>
				</div>
				<div class="nucleusitem">
					<div class="content">
						<div class="currentit"> {{getText().current}}服务人次</div>
						<div class="data">
							<span v-if="!state1||!state2">0</span>
							<animate-number v-else from="0" :to="servicesTimes.current"
								:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
							<el-tooltip effect="dark" placement="top-start">
								<div slot="content" style="line-height: 20px;">
									<div>病例：{{shopDetail.current&&shopDetail.current.servicesTimes_Case}}</div>
									<div>医疗套餐：{{shopDetail.current&&shopDetail.current.servicesTimes_Medical}}</div>
									<div>疫苗驱虫：{{shopDetail.current&&shopDetail.current.servicesTimes_VD}}</div>
									<div>洗美：{{shopDetail.current&&shopDetail.current.servicesTimes_Washing}}</div>
								</div>
								<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:10px;" />
							</el-tooltip>
						</div>
						<div v-if="servicesTimes.old===0" class="compare" style="padding-top: 5px;">{{getText().old}}为 0
						</div>
						<div v-else class="compare">
							比
							<el-tooltip effect="dark" :content="servicesTimes.old+''" placement="left">
								<span>{{getText().old}}</span>
							</el-tooltip>
							{{servicesTimes.rate}}%
							<img v-if="servicesTimes.rate>=0" src="../../assets/img/lvzhang.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
							<img v-if="servicesTimes.rate<0" src="../../assets/img/hongdie.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
						</div>
					</div>
				</div>
				<div class="nucleusitem">
					<div class="content">
						<div class="currentit"> {{getText().current}}收入</div>
						<div class="data">
							<span v-if="!state1||!state2">0</span>
							<animate-number v-else from="0" :to="incomeAmount.current"
								:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
							<el-tooltip effect="dark" placement="top-start">
								<div slot="content" style="line-height: 20px;">
									<div>订单：{{shopDetail.current&&shopDetail.current.incomeAmount_OrderAmount}}</div>
									<div>退货：{{shopDetail.current&&shopDetail.current.incomeAmount_ReturnAmount}}</div>
									<div>换单：{{shopDetail.current&&shopDetail.current.incomeAmount_ReplaceAmount}}</div>
									<div>洗美：{{shopDetail.current&&shopDetail.current.incomeAmount_WashingCardAmount}}
									</div>
									<div>疫苗驱虫：{{shopDetail.current&&shopDetail.current.incomeAmount_VDCardAmount}}</div>
								</div>
								<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:10px;" />
							</el-tooltip>
						</div>
						<div v-if="incomeAmount.old===0" class="compare" style="padding-top: 5px;">{{getText().old}}为 0
						</div>
						<div v-else class="compare">
							比
							<el-tooltip effect="dark" :content="incomeAmount.old+''" placement="left">
								<span>{{getText().old}}</span>
							</el-tooltip>
							{{incomeAmount.rate}}%
							<img v-if="incomeAmount.rate>=0" src="../../assets/img/lvzhang.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
							<img v-if="incomeAmount.rate<0" src="../../assets/img/hongdie.png"
								style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
						</div>
					</div>
				</div>
				<div class="nucleusitem" style="margin-right: 0;">
					<div class="content">
						<div class="currentit"> 会员余额</div>
						<div class="data">
							<span v-if="!state1||!state2">0</span>
							<animate-number v-else from="0" :to="liabilityAmount.current"
								:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
							<el-tooltip effect="dark" placement="top-start">
								<div slot="content" style="line-height: 20px;">
									<div>订金：{{shopDetail.current&&shopDetail.current.liabilityAmount_Deposit}}</div>
									<div>洗美卡：{{shopDetail.current&&shopDetail.current.liabilityAmount_WashingCard}}
									</div>
									<div>余额：{{shopDetail.current&&shopDetail.current.liabilityAmount_Yue}}</div>
									<div style="line-height: 6px;">----------------------------</div>
									<div>余额人数：{{shopDetail.current&&shopDetail.current.liabilityAmount_Yue_Count}}</div>
								</div>
								<img src="../../assets/img/icon_eye.jpg" style="width:20px;margin-left:10px;" />
							</el-tooltip>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="samedaystatistics">
			<div class="sameday">
				<div class="samedayTit">
					<div class="tit">{{getText().current}}店内数据</div>
				</div>
				<div class="samedayCon">
					<div class="samedayItem">
						<div class="samedayContent">
							<div class="samedayContentTit"> {{getText().current}}订单数 </div>
							<div class="samedayContentData">
								<span v-if="!state1||!state2">0</span>
								<animate-number v-else from="0" :to="currentConsumeOrderCount.current"
									:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
							</div>
							<div v-if="currentConsumeOrderCount.old===0" class="samedayContentCompare" style="">
								{{getText().old}}为 0
							</div>
							<div v-else class="samedayContentCompare">
								比
								<el-tooltip effect="dark" :content="currentConsumeOrderCount.old+''" placement="left">
									<span>{{getText().old}}</span>
								</el-tooltip>
								{{currentConsumeOrderCount.rate}}%
								<img v-if="currentConsumeOrderCount.rate>=0" src="../../assets/img/lvzhang.png"
									style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
								<img v-if="currentConsumeOrderCount.rate<0" src="../../assets/img/hongdie.png"
									style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
							</div>
						</div>
					</div>
					<div class="samedayItem">
						<div class="samedayContent">
							<div class="samedayContentTit"> {{getText().current}}退换货单数 </div>
							<div class="samedayContentData">
								<span v-if="!state1||!state2">0</span>
								<animate-number v-else from="0" :to="returnOrderCount.current"
									:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
							</div>
							<div v-if="returnOrderCount.old===0" class="samedayContentCompare" style="">
								{{getText().old}}为 0
							</div>
							<div v-else class="samedayContentCompare">
								比
								<el-tooltip effect="dark" :content="returnOrderCount.old+''" placement="left">
									<span>{{getText().old}}</span>
								</el-tooltip>
								{{returnOrderCount.rate}}%
								<img v-if="returnOrderCount.rate>=0" src="../../assets/img/lvzhang.png"
									style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
								<img v-if="returnOrderCount.rate<0" src="../../assets/img/hongdie.png"
									style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
							</div>
						</div>
					</div>
					<div class="samedayItem">
						<div class="samedayContent">
							<div class="samedayContentTit"> {{getText().current}}进店会员数 </div>
							<div class="samedayContentData">
								<span v-if="!state1||!state2">0</span>
								<animate-number v-else from="0" :to="currentEnterShopMemberCount.current"
									:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
							</div>
							<div v-if="currentEnterShopMemberCount.old===0" class="samedayContentCompare" style="">
								{{getText().old}}为 0
							</div>
							<div v-else class="samedayContentCompare">
								比
								<el-tooltip effect="dark" :content="currentEnterShopMemberCount.old+''"
									placement="left">
									<span>{{getText().old}}</span>
								</el-tooltip>
								{{currentEnterShopMemberCount.rate}}%
								<img v-if="currentEnterShopMemberCount.rate>=0" src="../../assets/img/lvzhang.png"
									style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
								<img v-if="currentEnterShopMemberCount.rate<0" src="../../assets/img/hongdie.png"
									style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
							</div>
						</div>
					</div>
					<div class="samedayItem">
						<div class="samedayContent">
							<div class="samedayContentTit"> {{getText().current}}新增会员数 </div>
							<div class="samedayContentData">
								<span v-if="!state1||!state2">0</span>
								<animate-number v-else from="0" :to="currentNewMemberCount.current"
									:formatter="(num)=>{return num.toFixed(2)}"></animate-number>
							</div>
							<div v-if="currentNewMemberCount.old===0" class="samedayContentCompare" style="">
								{{getText().old}}为 0
							</div>
							<div v-else class="samedayContentCompare">
								比
								<el-tooltip effect="dark" :content="currentNewMemberCount.old+''" placement="left">
									<span>{{getText().old}}</span>
								</el-tooltip>{{currentNewMemberCount.rate}}%
								<img v-if="currentNewMemberCount.rate>=0" src="../../assets/img/lvzhang.png"
									style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;" />
								<img v-if="currentNewMemberCount.rate<0" src="../../assets/img/hongdie.png"
									style="width: 20px;height: 20px;vertical-align: sub;margin-left: -5px;transform:rotate(180deg)" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="hotmoney">
				<div class="hotmoneyTit">
					<div class="tit">{{getText().current}}销售爆款商品</div>
				</div>
				<div class="hotmoneyCon">
					<div class="hotmoneyItem">
						<div class="hotmoneyContent">
							<div class="hotmoneyContentDesc">{{getText().current}}销售<span
									style="color:#F72222;">单品数量</span>累计最高</div>
							<el-tooltip effect="dark" :content="goodsHighestSaleCountInfo.productName"
								placement="top-start">
								<div class="hotmoneyContentTit">{{goodsHighestSaleCountInfo.productName}}</div>
							</el-tooltip>
							<div class="hotmoneyContentNum">销售数量：{{goodsHighestSaleCountInfo.saleCount}}</div>
							<div class="hotmoneyContentPrice">金额：¥{{goodsHighestSaleCountInfo.saleAmount}}</div>
						</div>
					</div>
					<div class="hotmoneyItem">
						<div class="hotmoneyContent">
							<div class="hotmoneyContentDesc">{{getText().current}}销售<span
									style="color:#F72222;">单品金额</span>累计最高</div>
							<el-tooltip effect="dark" :content="goodsHighestSaleAmountInfo.productName"
								placement="top-start">
								<div class="hotmoneyContentTit">{{goodsHighestSaleAmountInfo.productName}}</div>
							</el-tooltip>
							<div class="hotmoneyContentNum">销售数量：{{goodsHighestSaleAmountInfo.saleCount}}</div>
							<div class="hotmoneyContentPrice">金额：¥{{goodsHighestSaleAmountInfo.saleAmount}}</div>
						</div>
					</div>
					<div class="hotmoneyItem">
						<div class="hotmoneyContent">
							<div class="hotmoneyContentDesc">{{getText().current}}销售<span
									style="color:#F72222;">活体数量</span>累计最高</div>
							<el-tooltip effect="dark" :content="petHighestSaleCountInfo.productName"
								placement="top-start">
								<div class="hotmoneyContentTit">{{petHighestSaleCountInfo.productName}}</div>
							</el-tooltip>
							<div class="hotmoneyContentNum">销售数量：{{petHighestSaleCountInfo.saleCount}}</div>
							<div class="hotmoneyContentPrice">金额：¥{{petHighestSaleCountInfo.saleAmount}}</div>
						</div>
					</div>
					<div class="hotmoneyItem">
						<div class="hotmoneyContent">
							<div class="hotmoneyContentDesc">{{getText().current}}销售<span
									style="color:#F72222;">活体金额</span>累计最高</div>
							<el-tooltip effect="dark" :content="petHighestSaleAmountInfo.productName"
								placement="top-start">
								<div class="hotmoneyContentTit">{{petHighestSaleAmountInfo.productName}}</div>
							</el-tooltip>
							<div class="hotmoneyContentNum">销售数量：{{petHighestSaleAmountInfo.saleCount}}</div>
							<div class="hotmoneyContentPrice">金额：¥{{petHighestSaleAmountInfo.saleAmount}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pieChart">
			<div class="pieChartL">
				<div class="pieItem">
					<div class="pieTit">
						<div class="tit">总销售额</div>
						<div class="titR">
							<el-radio-group v-model="radio" @change="changeRadio">
								<el-radio :label="1">订单类型</el-radio>
								<el-radio :label="2">门店筛选</el-radio>
								<!-- <el-radio :label="3">门店流水</el-radio> -->
							</el-radio-group>
						</div>
					</div>
					<div class="pie0" style="position: relative;padding-bottom: 80px;">
						<div id="pie0" style="height: 400px;"></div>
						<div
							style="position: absolute;width:160px;height: 160px;border-radius: 50%;background-color: #fff;top:100px;left:100px;text-align: center;font-size: 20px;line-height: 40px;">
							<div style="padding-top:35px;color:#7c7d7c;">总销售额</div>
							<div style="font-size: 30px;color:#1a1a1a;font-weight: bold;">
								{{$public.jia(data1.saleAmount,data2.saleAmount,data3.saleAmount,data4.saleAmount)}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pieChartR">
				<div class="pieItem" style="margin-bottom:10px;">
					<div class="pieTit">
						<div class="tit">金水区店销售额</div>
					</div>
					<div class="pie1" style="position: relative;min-width:330px;max-width: 60%;margin:auto;">
						<div id="pie1" style="height: 200px;"></div>
						<div
							style="position: absolute;width:70px;height: 70px;border-radius: 50%;background-color: #fff;top:80px;left:85px;text-align: center;font-size: 12px;line-height: 20px;">
							<div style="padding-top:16px;color:#7c7d7c;">总销售额</div>
							<div style="font-size: 16px;color:#1a1a1a;font-weight: bold;">{{data1.saleAmount}}</div>
						</div>
					</div>
				</div>
				<div class="pieItem">
					<div class="pieTit">
						<div class="tit">陇海店销售额</div>
					</div>
					<div class="pie1" style="position: relative;min-width:330px;max-width: 60%;margin:auto;">
						<div id="pie2" style="height: 200px;"></div>
						<div
							style="position: absolute;width:70px;height: 70px;border-radius: 50%;background-color: #fff;top:80px;left:85px;text-align: center;font-size: 12px;line-height: 20px;">
							<div style="padding-top:16px;color:#7c7d7c;">总销售额</div>
							<div style="font-size: 16px;color:#1a1a1a;font-weight: bold;">{{data2.saleAmount}}</div>
						</div>
					</div>
				</div>
				<div class="pieItem">
					<div class="pieTit">
						<div class="tit">东区店销售额</div>
					</div>
					<div class="pie1" style="position: relative;min-width:330px;max-width: 60%;margin:auto;">
						<div id="pie3" style="height: 200px;"></div>
						<div
							style="position: absolute;width:70px;height: 70px;border-radius: 50%;background-color: #fff;top:80px;left:85px;text-align: center;font-size: 12px;line-height: 20px;">
							<div style="padding-top:16px;color:#7c7d7c;">总销售额</div>
							<div style="font-size: 16px;color:#1a1a1a;font-weight: bold;">{{data3.saleAmount}}</div>
						</div>
					</div>
				</div>
				<div class="pieItem">
					<div class="pieTit">
						<div class="tit">拓展部销售额</div>
					</div>
					<div class="pie1" style="position: relative;min-width:330px;max-width: 60%;margin:auto;">
						<div id="pie4" style="height: 200px;"></div>
						<div
							style="position: absolute;width:70px;height: 70px;border-radius: 50%;background-color: #fff;top:80px;left:85px;text-align: center;font-size: 12px;line-height: 20px;">
							<div style="padding-top:16px;color:#7c7d7c;">总销售额</div>
							<div style="font-size: 16px;color:#1a1a1a;font-weight: bold;">{{data4.saleAmount}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	// import veRing from 'v-charts/lib/ring.common'
	import echarts from "echarts";
	export default {
		data() {
			return {
				currDate: '',
				params: {
					dateType: 'date',
					shopId: this.$store.getters.curShopInfo.shop_id,
					currDate: '',
				},

				state1: false,
				state2: false,

				shopDetail: {},
				runningAmount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 流水金额
				rechargeAmount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 充值金额
				singleCustomerAmount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 客单价
				shopUseAmount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 自用金额
				servicesTimes: {
					current: 0,
					old: 0,
					rate: 0
				}, // 服务人次
				incomeAmount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 收入金额
				liabilityAmount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 负债金额

				currentConsumeOrderCount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 订单数
				returnOrderCount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 退换单数
				currentEnterShopMemberCount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 进店会员数
				currentNewMemberCount: {
					current: 0,
					old: 0,
					rate: 0
				}, // 新增会员数
				goodsHighestSaleCountInfo: {
					productId: '',
					productName: '',
					saleCount: '',
					saleAmount: ''
				}, //商品 最高销售 数量 信息
				goodsHighestSaleAmountInfo: {
					productId: '',
					productName: '',
					saleCount: '',
					saleAmount: ''
				}, //商品 最高销售 金额 信息
				petHighestSaleCountInfo: {
					productId: '',
					productName: '',
					saleCount: '',
					saleAmount: ''
				}, //活体 最高销售 数量 信息
				petHighestSaleAmountInfo: {
					productId: '',
					productName: '',
					saleCount: '',
					saleAmount: ''
				}, //活体 最高销售 金额 信息

				shopList: [],

				radio: 1,
				myChart0: null,
				myChart1: null,
				myChart2: null,
				myChart3: null,
				myChart4: null,

				data0: {},
				data1: {},
				data2: {},
				data3: {},
				data4: {},
			}
		},
		computed: {
			shopId() {
				return this.$store.state.shopId;
			}
		},
		created() {
			// let shops = this.$store.getters['shopList'];
			// for(let i=0;i<shops.length;i++){
			// 	if(shops[i].shop_id==='5e9412e0b2bfbc089daerr12'||shops[i].shop_id==='5e9412e0b2bfbc089daerr13'||shops[i].shop_id==='5e9412e0b2bfbc089daerr15'||shops[i].shop_id==='5e9412e0b2bfbc089daerr16')
			// 	this.shopList.push(shops[i])
			// }
			this.shopList = [{ shop_id: "5e9412e0b2bfbc089daerr10", shop_name: "驯养中心" },
  { shop_id: "5e9412e0b2bfbc089daerr11", shop_name: "小程序店" },
  { shop_id: "5e9412e0b2bfbc089daerr12", shop_name: "金水区店" },
  { shop_id: "5e9412e0b2bfbc089daerr14", shop_name: "指挥中心" },
  { shop_id: "5e9412e0b2bfbc089daerr17", shop_name: "线上旗舰店" },
  { shop_id: "5e9412e0b2bfbc089daerr18", shop_name: "郑东新区店" },
{shop_id:"5e9412e0b2bfbc089daerr15",shop_name: "东区店" },
{shop_id:"5e9412e0b2bfbc089daerr13",shop_name: "陇海店" },
{shop_id:"5e9412e0b2bfbc089daerr16",shop_name: "二七店" }]
			this.currDate = new Date();
			this.params.currDate = this.$public.FTimeStr10(new Date());
			this.clickSearch();
		},
		mounted() {
			this.myChart0 = echarts.init(document.getElementById("pie0"));
			this.myChart1 = echarts.init(document.getElementById("pie1"));
			this.myChart2 = echarts.init(document.getElementById("pie2"));
			this.myChart3 = echarts.init(document.getElementById("pie3"));
			this.myChart4 = echarts.init(document.getElementById("pie4"));
		},
		methods: {
			getText() {
				if (this.params.dateType === 'date') {
					return {
						current: '当日',
						old: '前一日'
					}
				} else if (this.params.dateType === 'week') {
					return {
						current: '当周',
						old: '前一周'
					}
				} else if (this.params.dateType === 'month') {
					return {
						current: '当月',
						old: '前一月'
					}
				} else if (this.params.dateType === 'year') {
					return {
						current: '当年',
						old: '前一年'
					}
				} else {
					return {
						current: '当日',
						old: '前一日'
					}
				}
			},
			changeShop() {
				this.clickSearch()
			},
			changePicker(val) {
				this.params.currDate = this.$public.FTimeStr10(val);
				this.clickSearch()
			},
			changeDateType() {
				this.clickSearch()
			},
			changeRadio(a) {
				if (a === 2) {
					this.drawAll(this.myChart0, this.data0, 'shops')
				} else if (a === 1) {
					this.drawAll(this.myChart0, this.data0, 'order')
				} else if (a === 3) {
					this.drawAll(this.myChart0, this.data0, 'order')
				}
			},
			clickSearch() {
				this.getDataByShopId();
				this.getDataForAllShop();
			},
			getDataByShopId() {
				this.state1 = false;
				let params = {
					time: this.params.currDate, // 查看的时间;时间戳
					way: this.params.dateType, // date:本日 week:本周 month:本月 season:本季度 year:本年
					shopId: this.params.shopId,
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url9 + 'api/Statistics/shop/sum/data', params).then(res => {
					this.$nextTick(() => {
						this.state1 = true;
						if (this.state1 && this.state2) {
							loading.close();
						}
					})
					if (res.code == 0) {
						this.shopDetail = res.data;
						let d = res.data;
						this.runningAmount = {
							current: d.current.runningAmount,
							old: d.old.runningAmount,
							rate: d.old.runningAmount === 0 ? 0 : this.$public.chu_1(this.$public.jian_1(d
									.current.runningAmount, d.old.runningAmount) * 100, d.old
								.runningAmount)
						};
						this.rechargeAmount = {
							current: d.current.rechargeAmount,
							old: d.old.rechargeAmount,
							rate: d.old.rechargeAmount === 0 ? 0 : this.$public.chu_1(this.$public.jian_1(d
									.current.rechargeAmount, d.old.rechargeAmount) * 100, d.old
								.rechargeAmount)
						};
						this.singleCustomerAmount = {
							current: d.current.singleCustomerAmount,
							old: d.old.singleCustomerAmount,
							rate: d.old.singleCustomerAmount === 0 ? 0 : this.$public.chu_1(this.$public
								.jian_1(d.current.singleCustomerAmount, d.old.singleCustomerAmount) * 100,
								d.old.singleCustomerAmount)
						};
						this.shopUseAmount = {
							current: d.current.shopUseAmount,
							old: d.old.shopUseAmount,
							rate: d.old.shopUseAmount === 0 ? 0 : this.$public.chu_1(this.$public.jian_1(d
									.current.shopUseAmount, d.old.shopUseAmount) * 100, d.old
								.shopUseAmount)
						};
						this.servicesTimes = {
							current: d.current.servicesTimes,
							old: d.old.servicesTimes,
							rate: d.old.servicesTimes === 0 ? 0 : this.$public.chu_1(this.$public.jian_1(d
									.current.servicesTimes, d.old.servicesTimes) * 100, d.old
								.servicesTimes)
						};
						this.incomeAmount = {
							current: d.current.incomeAmount,
							old: d.old.incomeAmount,
							rate: d.old.incomeAmount === 0 ? 0 : this.$public.chu_1(this.$public.jian_1(d
								.current.incomeAmount, d.old.incomeAmount) * 100, d.old.incomeAmount)
						};
						this.liabilityAmount = {
							current: d.current.liabilityAmount,
							old: d.old.liabilityAmount,
							rate: d.old.liabilityAmount === 0 ? 0 : this.$public.chu_1(this.$public.jian_1(d
									.current.liabilityAmount, d.old.liabilityAmount) * 100, d.old
								.liabilityAmount)
						};

						this.currentConsumeOrderCount = {
							current: d.current.currentConsumeOrderCount,
							old: d.old.currentConsumeOrderCount,
							rate: d.old.currentConsumeOrderCount === 0 ? 0 : this.$public.chu_1(this.$public
								.jian_1(d.current.currentConsumeOrderCount, d.old
									.currentConsumeOrderCount) * 100, d.old.currentConsumeOrderCount)
						};
						this.returnOrderCount = {
							current: d.current.returnOrderCount,
							old: d.old.returnOrderCount,
							rate: d.old.returnOrderCount === 0 ? 0 : this.$public.chu_1(this.$public.jian_1(d
									.current.returnOrderCount, d.old.returnOrderCount) * 100, d.old
								.returnOrderCount)
						};
						this.currentEnterShopMemberCount = {
							current: d.current.currentEnterShopMemberCount,
							old: d.old.currentEnterShopMemberCount,
							rate: d.old.currentEnterShopMemberCount === 0 ? 0 : this.$public.chu_1(this.$public
								.jian_1(d.current.currentEnterShopMemberCount, d.old
									.currentEnterShopMemberCount) * 100, d.old.currentEnterShopMemberCount)
						};
						this.currentNewMemberCount = {
							current: d.current.currentNewMemberCount,
							old: d.old.currentNewMemberCount,
							rate: d.old.currentNewMemberCount === 0 ? 0 : this.$public.chu_1(this.$public
								.jian_1(d.current.currentNewMemberCount, d.old.currentNewMemberCount) *
								100, d.old.currentNewMemberCount)
						};

						this.goodsHighestSaleCountInfo = d.current.goodsHighestSaleCountInfo;
						this.goodsHighestSaleAmountInfo = d.current.goodsHighestSaleAmountInfo;
						this.petHighestSaleCountInfo = d.current.petHighestSaleCountInfo;
						this.petHighestSaleAmountInfo = d.current.petHighestSaleAmountInfo;
					}
				})
			},
			getDataForAllShop() {
				this.state2 = false;
				let params = {
					time: this.params.currDate, // 查看的时间;时间戳
					way: this.params.dateType, // date:本日 week:本周 month:本月 season:本季度 year:本年
					shopId: this.params.shopId,
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url9 + 'api/Statistics/allshop/sale', params).then(res => {
					this.$nextTick(() => {
						this.state2 = true;
						if (this.state1 && this.state2) {
							loading.close();
						}
					})
					if (res.code == 0) {
						let d = res.data;

						let arr = d.current.shopsSummaryData;
						for (let i = 0; i < arr.length; i++) {
							if (arr[i].shopId === '5e9412e0b2bfbc089daerr12') {
								this.data1 = arr[i];
								this.drawByShops(this.myChart1, this.data1)
							} else if (arr[i].shopId === '5e9412e0b2bfbc089daerr13') {
								this.data2 = arr[i];
								this.drawByShops(this.myChart2, this.data2)
							} else if (arr[i].shopId === '5e9412e0b2bfbc089daerr15') {
								this.data3 = arr[i];
								this.drawByShops(this.myChart3, this.data3)
							} else if (arr[i].shopId === '5e9412e0b2bfbc089daerr16') {
								this.data4 = arr[i];
								this.drawByShops(this.myChart4, this.data4)
							}
						}
						this.data0 = d.current.orderTypeSummaryInfo;
						if (this.radio === 2) {
							this.drawAll(this.myChart0, this.data0, 'shops')
						} else if (this.radio === 1) {
							this.drawAll(this.myChart0, this.data0, 'order')
						}
					}
				})
			},
			drawAll(chart, d, type) {
				if (type === 'order') {
					let arr = [];
					for (let i = 0; i < d.length; i++) {
						arr.push({
							value: d[i].orderSummaryAmount,
							name: d[i].orderTypeName
						})
					}
					chart.setOption({
						color: ['#F5882A', '#58A2F7', '#FBCB63', '#F76260', '#8167F5', '#F5EC67', '#28D3DB',
							'#96D9FF'
						],
						tooltip: {
							trigger: 'item'
						},
						legend: {
							orient: 'vertical',
							right: '30',
							top: 'middle',
							textStyle: {
								fontSize: '12',
								color: '#666',
								lineHeight: '30'
							},
							formatter: function(e) {
								for (let i = 0; i < d.length; i++) {
									if (d[i].orderTypeName === e) {
										return e + ' ' + d[i].orderSummaryAmount
									}
								}
							},
						},
						series: [{
							name: '访问来源',
							type: 'pie',
							radius: ['40%', '75%'],
							center: [180, 180],
							label: {
								position: 'inner',
								fontSize: 14,
								formatter: (val) => {
									return val.percent + '%';
								}
							},
							data: arr,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							},
							tooltip: {
								formatter: (val) => {
									return "<div>" +
										val.name + ":" + val.value + "(" + val.percent + "%)" +
										"<div style='padding-left:20px;'>" +
										"北环:" + this.data1.orderTypeList.filter((item) => {
											if (item.orderTypeName === val.name) {
												return item
											}
										})[0].orderSummaryAmount +
										"</div>" +
										"<div style='padding-left:20px;'>" +
										"陇海:" + this.data2.orderTypeList.filter((item) => {
											if (item.orderTypeName === val.name) {
												return item
											}
										})[0].orderSummaryAmount +
										"</div>" +
										"<div style='padding-left:20px;'>" +
										"东区:" + this.data3.orderTypeList.filter((item) => {
											if (item.orderTypeName === val.name) {
												return item
											}
										})[0].orderSummaryAmount +
										"</div>" +
										"<div style='padding-left:20px;'>" +
										"二七:" + this.data4.orderTypeList.filter((item) => {
											if (item.orderTypeName === val.name) {
												return item
											}
										})[0].orderSummaryAmount +
										"</div>" +
										"</div>"
								}
							}
						}, ]
					})
				} else if (type === 'shops') {
					let arr = [{
							value: this.data1.saleAmount,
							name: '北环'
						},
						{
							value: this.data2.saleAmount,
							name: '陇海'
						},
						{
							value: this.data3.saleAmount,
							name: '东区'
						},
						{
							value: this.data4.saleAmount,
							name: '二七'
						},
					];
					chart.setOption({
						color: ['#F5882A', '#58A2F7', '#FBCB63', '#F76260', '#8167F5', '#F5EC67', '#28D3DB',
							'#96D9FF'
						],
						tooltip: {
							trigger: 'item'
						},
						legend: {
							orient: 'vertical',
							right: '30',
							top: 'middle',
							textStyle: {
								fontSize: '12',
								color: '#666',
								lineHeight: '30'
							},
							formatter: function(e) {
								for (let i = 0; i < arr.length; i++) {
									if (arr[i].name === e) {
										return e + ' ' + arr[i].value
									}
								}
							},
						},
						series: [{
							name: '访问来源',
							type: 'pie',
							radius: ['40%', '75%'],
							center: [180, 180],
							label: {
								position: 'inner',
								fontSize: 14,
								formatter: (val) => {
									return val.percent + '%';
								}
							},
							data: arr,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							},
							tooltip: {
								formatter: (val) => {
									return val.name + ":" + val.value
								}
							}
						}, ]
					})
				}
			},
			drawByShops(chart, d) {
				let arr = [];
				for (let i = 0; i < d.orderTypeList.length; i++) {
					arr.push({
						value: d.orderTypeList[i].orderSummaryAmount,
						name: d.orderTypeList[i].orderTypeName
					})
				}
				chart.setOption({
					color: ['#F5882A', '#58A2F7', '#FBCB63', '#F76260', '#8167F5', '#F5EC67', '#28D3DB',
						'#96D9FF'
					],
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						right: '10',
						top: 'middle',
						textStyle: {
							fontSize: '12',
							color: '#666',
							lineHeight: '15'
						},
						formatter: function(e) {
							for (let i = 0; i < d.orderTypeList.length; i++) {
								if (d.orderTypeList[i].orderTypeName === e) {
									return e.split("类")[0] + ' ' + d.orderTypeList[i].orderSummaryAmount
								}
							}
						},
					},
					series: [{
						name: '',
						type: 'pie',
						radius: ['35%', '70%'],
						center: [120, 115],
						label: {
							fontSize: 12,
							formatter: '{d}%'
						},
						data: arr,
						emphasis: {
							itemStyle: {
								shadowBlur: 5,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						},
						tooltip: {
							formatter: (val) => {
								return val.name + ":" + val.value + "(" + val.percent + "%)"
							}
						},
					}]
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.page {
		width: 100%;

		.top {
			color: #FF182A;
		}

		.dowm {
			color: #18A44C;
		}

		.statistical {
			background-color: #fff;
			margin-bottom: 10px;
		}

		.nucleustit {
			display: flex;
			justify-content: space-between;
			height: 57px;
			box-sizing: border-box;
			padding: 16px 16px 0 16px;
			background-color: #fff;

			.tit {
				color: $fontColor;
				font-size: 14px;
				font-weight: bold;
				border-left: 2px solid $mainColor;
				margin: 4px 0;
				padding: 0 6px;
				box-sizing: border-box;
				height: 20px;
				line-height: 20px;
			}
		}

		.nucleus {
			margin-top: 12px;

			.nucleuscon {
				display: flex;

				.nucleusitem {
					width: 100%;
					display: flex;
					padding: 12px 20px;
					height: 105px;
					box-sizing: border-box;
					margin-right: 12px;
					background-color: #fff;
					border-radius: 4px;

					&:last-child {
						border: none;
					}

					.content {}

					.currentit {
						color: #5f5f5f;
						font-size: 12px;
					}

					.data {
						margin: 13px 0;
						font-size: 20px;
						color: $fontColor;
					}

					.compare {
						font-size: 12px;
					}
				}
			}
		}

		.samedaystatistics {
			margin-top: 12px;
			display: flex;

			.sameday {
				width: 540px;
				background-color: #fff;
				box-sizing: border-box;
				margin-right: 12px;
				border-radius: 4px;
				flex-shrink: 0;
				height: 155px;
				overflow: hidden;

				.samedayTit {
					display: flex;
					justify-content: space-between;
					box-sizing: border-box;
					padding: 16px 16px 14px 16px;
					background-color: #fff;
					border-bottom: 1px solid #F2F2F2;

					.tit {
						color: $fontColor;
						font-size: 14px;
						font-weight: bold;
						border-left: 2px solid $mainColor;
						padding: 0 6px;
						box-sizing: border-box;
						height: 20px;
						line-height: 20px;
					}
				}

				.samedayCon {
					display: flex;
					justify-content: space-around;
					width: 100%;

					.samedayItem {
						border-right: 1px solid #F2F2F2;
						display: flex;
						width: 100%;
						box-sizing: border-box;
						margin-top: 12px;
						padding: 0 0 0 16px;

						&:last-child {
							border: none;
						}

						.samedayContent {
							color: $fontColor;

							.samedayContentTit {
								font-size: 12px;
							}

							.samedayContentData {
								margin: 14px 0;
								font-size: 24px;
								color: #1A1A1A;
							}

							.samedayContentCompare {
								font-size: 12px;
							}
						}
					}
				}
			}

			.hotmoney {
				width: 100%;
				background-color: #fff;
				box-sizing: border-box;

				.hotmoneyTit {
					display: flex;
					justify-content: space-between;
					box-sizing: border-box;
					padding: 16px 16px 14px 16px;
					background-color: #fff;
					border-bottom: 1px solid #F2F2F2;

					.tit {
						color: $fontColor;
						font-size: 14px;
						font-weight: bold;
						border-left: 2px solid $mainColor;
						padding: 0 6px;
						box-sizing: border-box;
						height: 20px;
						line-height: 20px;
					}
				}

				.hotmoneyCon {
					display: flex;

					.hotmoneyItem {
						border-right: 1px solid #D2D2D2;
						width: 25%;
						display: flex;
						justify-content: center;
						box-sizing: border-box;
						margin-top: 8px;

						&:last-child {
							border: none;
						}

						.hotmoneyContent {
							width: 100%;
							padding-left: 12px;
							box-sizing: border-box;

							.hotmoneyContentTit {
								color: $mainColor;
								font-size: 14px;
								font-weight: bold;
								padding: 4px 0;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								line-height: 18px;
								height: 18px;
							}

							.hotmoneyContentNum {
								color: #666;
								font-size: 12px;
								padding: 4px 0;
							}

							.hotmoneyContentPrice {
								color: #666;
								font-size: 12px;
								padding: 4px 0;
							}

							.hotmoneyContentDesc {
								color: #000000;
								font-size: 12px;
								font-weight: bold;
								padding: 4px 0;
							}
						}
					}
				}

			}
		}

		.pieChart {
			display: flex;
			margin-top: 12px;

			.pieTit {
				display: flex;
				justify-content: space-between;
				box-sizing: border-box;
				padding: 16px 16px 5px 16px;
				background-color: #fff;

				.tit {
					color: $fontColor;
					font-size: 14px;
					font-weight: bold;
					border-left: 2px solid $mainColor;
					padding: 0 6px;
					box-sizing: border-box;
					height: 20px;
					line-height: 20px;
				}
			}

			.pieChartL {
				width: 540px;
				margin-right: 12px;
				flex-shrink: 0;

				.pieItem {
					background-color: #fff;
				}
			}

			.pieChartR {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.pieItem {
					background-color: #fff;
					width: calc((100% - 12px)/2);
					height: 260px;
					box-sizing: border-box;
				}
			}
		}
	}
</style>
